import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton } from "@fluentui/react";
const backIcon = { iconName: "Back" };
const homeIcon = { iconName: "Home" };
const WorkbenchHeader = ({ onBack, onHome, title, isDuplicate }) => (_jsxs("div", { children: [_jsxs("header", { style: { display: "flex", alignItems: "center", padding: "0px" }, children: [_jsx(IconButton, { iconProps: backIcon, title: "Back", ariaLabel: "Back", onClick: onBack, styles: { root: { marginRight: 4 } } }), _jsx(IconButton, { iconProps: homeIcon, title: "Home", ariaLabel: "Home", onClick: onHome, styles: { root: { marginRight: 8 } } }), _jsx("h3", { style: { margin: 0, padding: "20px 4px" }, children: title })] }), isDuplicate && (_jsx("div", { style: {
                paddingLeft: "20px",
                fontSize: "14px",
                fontWeight: "bold",
                marginLeft: "20px",
                marginBottom: "10px"
            }, children: "Sent for ingestion" }))] }));
export default WorkbenchHeader;
